<script setup lang="ts">
/** @deprecated Используйте <UiButton shape="square"> */
const { size = 'm', color = 'none' } = defineProps<{
  size?: 's' | 'm' | 'l';
  color?: 'none' | 'light-gray' | 'gray' | 'black';
  error?: boolean;
}>();
</script>

<template>
  <button
    type="button"
    class="ui-button-icon"
    :class="[`_size-${size}`, `_color-${color}`, { _error: error }]"
  >
    <slot />
  </button>
</template>

<style scoped lang="scss">
.ui-button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity var(--transition-fast);

  &:disabled {
    opacity: 0.5;
  }

  &._size-s {
    width: 16px;
    height: 16px;
  }

  &._size-m {
    width: 24px;
    height: 24px;
  }

  &._size-l {
    width: 36px;
    height: 36px;
  }

  @mixin color($color, $hover) {
    color: $color;

    &:not(:disabled) {
      @media (hover: hover) {
        &:hover {
          color: $hover;
        }
      }
    }

    :deep(svg) {
      fill: currentcolor;
      transition: fill var(--transition-fast);
    }
  }

  &._color-light-gray {
    @include color(var(--color-gray-500), var(--color-gray-600));
  }

  &._color-gray {
    @include color(var(--color-gray-600), var(--color-gray-800));
  }

  &._color-black {
    @include color(var(--color-gray-1000), var(--color-gray-800));
  }

  :deep(svg) {
    transition: all var(--transition-fast);
  }

  &._error {
    color: var(--color-red-800);

    &:not(:disabled) {
      @media (hover: hover) {
        &:hover {
          color: var(--color-red-1000);
        }
      }
    }

    :deep(svg) {
      fill: currentcolor;
    }
  }
}
</style>
